import { TBucketFeed, TBucketFeed_LEGACY } from '../types';

export const bucketFeedIsoLegacyBucketFeed: Iso<
  TBucketFeed,
  TBucketFeed_LEGACY
> = {
  get: (bucketFeed) => ({
    id: bucketFeed.id,
    view_series: bucketFeed.seriesId,
    bucket_name: bucketFeed.name,
    disabled: bucketFeed.disabled,
    region: bucketFeed.region,
    scheduledFrequency: bucketFeed.frequency,
    time: bucketFeed.time,
    timezone: bucketFeed.timezone,
  }),
  reverseGet: (bucketFeed_LEGACY) => ({
    id: bucketFeed_LEGACY.id,
    seriesId: bucketFeed_LEGACY.view_series,
    name: bucketFeed_LEGACY.bucket_name,
    disabled: bucketFeed_LEGACY.disabled,
    region: bucketFeed_LEGACY.region,
    frequency: bucketFeed_LEGACY.scheduledFrequency,
    time: bucketFeed_LEGACY.time,
    timezone: bucketFeed_LEGACY.timezone,
  }),
};
